/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IInitData, IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {ISpinGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/ISpinServerData";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {ICreepyCarnivalTwoInitData} from "./data/ICreepyCarnivalTwoServerData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {CCTwoInitialWPEvents} from "../winpresentation/initial/CreepyCarnivalTwoInitialWPController";

export class CreepyCarnivalTwoServerDataParser extends SpinServerDataParser {

    private _isRestore: boolean = false;

    constructor() {
        super();
    }
    public parseReels(rawData: IServerData): string[][] {
        return this.parseReelArrays(rawData.reels);
    }

    public parseRespinPositionsAfter(rawData: ICreepyCarnivalTwoInitData): boolean[] {
        return this.parseRespinPositions(rawData);
    }

    public parseIsRestoreState(rawData: IInitData): boolean {
        this._isRestore = rawData.isRestoreState;

        return rawData.isRestoreState;
    }

    public parseWinPositions(rawData: any): boolean[][] {
        return rawData.winPositions;
    }

    public calculateSpecialSymbolsLength(rawData: ICreepyCarnivalTwoInitData): number {
        EventHandler.dispatchEvent(new GameEvent(CCTwoInitialWPEvents.CHANGE_BET_FOR_STAR_SPIN, {newBet : rawData.starSpinBetValue}));
        if (rawData.starSpinSymbolsCollected) {
            return rawData.starSpinSymbolsCollected.length;
        }
        return 0;


    }

    public getSpecialSymbolsArray(rawData: ICreepyCarnivalTwoInitData): any[] {
        if (rawData.starSpinSymbolsCollected) {
            return rawData.starSpinSymbolsCollected;
        } else {
            return rawData.starSpinSymbolsCollectedAfter;
        }
        return [];
    }

    public calculateSpecialSymbolsLengthBefore(rawData: ICreepyCarnivalTwoInitData): number {
        if (rawData.starSpinSymbolsCollectedBefore) {
            return rawData.starSpinSymbolsCollectedBefore.length;
        } else {
            return 0;
        }
    }

    public calculateSpecialSymbolsLengthAfter(rawData: ICreepyCarnivalTwoInitData): number {
        if (rawData.starSpinSymbolsCollectedAfter) {
            return rawData.starSpinSymbolsCollectedAfter.length;
        } else {
            return 0;
        }
    }

    public getSpecialSymbolsArrayAfter(rawData: ICreepyCarnivalTwoInitData): any[] {
        if (rawData.starSpinSymbolsCollectedAfter) {
            return rawData.starSpinSymbolsCollectedAfter;
        }
        return [];
    }

    /**
     * @description: to create 15 reels individually from the response that we get of 3*5 matrix of reels.
     * @param {array} rawReels 2d array of 3*5 reels.
     * @returns: {array} 15 individual reels.
     */
    private parseReelArrays(rawReels: string[][]): string[][] {
        let result: string[][] = [];

        for (let i: number = 0; i < rawReels.length; i++) {
            for (let j: number = 0; j < rawReels[i].length; j++) {
                result.push([rawReels[i][j]]);
            }
        }
        return result;
    }

    private parseRespinPositions(rawData: ICreepyCarnivalTwoInitData): boolean[] {
        if (this._isRestore) {
            this._isRestore = false;
            return rawData.respinPositions;
        } else {
            return rawData.respinPositionsAfter;
        }
    }

    public parseNearWinReels(rawData:ISpinGameData):boolean[] {
        return rawData.nearWinReels == null ? ArrayHelper.initArrayWithValues(GameConfig.instance.REELS_NUM, () => false) : (rawData.nearWinReels).reduce((acc, currEl) => acc.concat(<any>currEl), []);
    }
}